import React, { useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import useStyles from "../style";
import { customBaseUrl, httpPost } from "../../../store/http";
import Swal from "sweetalert2";
import { hideLoader, showLoader } from "../../../utils/loader";

const NewUnit = ({
  showUnitModal,
  setShowUnitModal,
  getMenus,
}) => {
  const styles = useStyles();
  const [data, setData] = useState({ name: '', description: '', isActive: true })

  const onHideModal = useCallback(() => {
    setShowUnitModal(false);
  }, [setShowUnitModal]);

  const handleSave = useCallback(async () => {
    if (!data.name || !data?.description) return
    showLoader();

    const res = await httpPost(`${customBaseUrl.roleUrl}/api/v1/menu/`, data)

    if (res.status) {
      hideLoader();
      onHideModal();
      getMenus();
      Swal.fire('Done', res?.message);
    } else {
      hideLoader();
    }
  }, [data, onHideModal, getMenus]);

  return (
    <Modal
      className={styles.modal}
      show={showUnitModal}
      onHide={onHideModal}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        style={{
          borderBottom: "none",
          padding: "2rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        closeButton
      >
        <span
          style={{
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "24px",
            textAlign: "center",
            width: "100%",
            color: "#000",
          }}
        >
          Create Menu
        </span>
      </Modal.Header>

      <Modal.Body>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          }}
        >
          <label>Menu Name</label>
          <input
            className="form-control"
            onChange={(e) => setData({ ...data, name: e?.target?.value })}
            value={data?.name}
          />
        </div>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
            marginTop: "15px"
          }}
        >
          <label>Menu Descriptions</label>
          <input
            className="form-control"
            onChange={(e) => setData({ ...data, description: e?.target?.value })}
            value={data?.description}
          />
        </div>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
            marginTop: "15px"
          }}
        >
          <label>Status</label>
          <select
            className='form-select border'
            value={data?.isActive}
            onChange={(e) => setData({ ...data, isActive: e?.target?.value === 'true' })}
          >
            <option value="true">TRUE</option>
            <option value="false">FALSE</option>
          </select>
        </div>
        <div style={{ display: 'flex', margin: 20, justifyContent: 'center', alignItems: 'center' }}>
          <button className="btn btn-primary" onClick={handleSave}>Save</button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NewUnit;